export interface AavoDialogStackEntry {
	containsTarget: (target: EventTarget | null) => boolean;
	id: string;
}

const dialogStack: AavoDialogStackEntry[] = [];

export function registerAavoDialogStackEntry(entry: AavoDialogStackEntry): () => void {
	dialogStack.push(entry);
	return () => {
		const index = dialogStack.findIndex((stackEntry) => stackEntry.id === entry.id);
		if (index >= 0) dialogStack.splice(index, 1);
	};
}

export function shouldCloseAavoDialogOnExternalEscape(dialogId: string, target: EventTarget | null): boolean {
	const topmostDialog = dialogStack.at(-1);
	return topmostDialog?.id === dialogId && !topmostDialog.containsTarget(target);
}
